import React from "react";
import { Route, Routes } from "react-router-dom";
import LandingPage from "../Pages/Tracker/LandingPage";
import StatusPage from "../Pages/Tracker/StatusPage";
import ThankyouPage from "../Pages/Tracker/ThankyouPage";
import UploadPage from "../Pages/Tracker/UploadDocumentPage";
import AppointmentBookingPage from "../Pages/Tracker/AppointmentBookingPage"
import TeleMedicalBookingPage from "../Pages/Tracker/TeleMedicalBookingPage"
import { useSelector } from "react-redux";
import MedicalUploadPage from "../Pages/Tracker/UploadDocumentPage/MedicalUploadPage";

const AppRoutes = () => {
  const normalFlow = useSelector((state) => state.trackPolicyDetails.normalFlowForUpload)
  return (
    <Routes>
      <Route path=''>
        <Route index element={<LandingPage />} />
        <Route path="status" element={<StatusPage />} />
        <Route path="appointment-booking" element={<AppointmentBookingPage />} />
        <Route path="tele-medical-booking" element={<TeleMedicalBookingPage />} />
      <Route path="upload" element={normalFlow ? <UploadPage /> : <MedicalUploadPage />} />
      <Route path="thankyou" element={<ThankyouPage />}/>
      </Route>
    </Routes>
  );
};

export default AppRoutes;
